"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = void 0;
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIconButton = (0, styled_components_1.default)(IconButton_1.default) `
  padding: 0;
`;
